import { Container } from '@mui/material';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import Page from '../../../components/Page';
import { useParams } from 'react-router-dom';
import AddOnProductForm from './AddonProductForm';

const index = () => {
  const params: any = useParams();
  const isAddMode = !params?.id;
  return (
    <Page title={'Add-on Product'}>
      <Container maxWidth={'xl'}>
        <HeaderBreadcrumbs
          heading={`${isAddMode ? 'Add Add-on Product' : 'Edit Add-on Product'} `}
          links={[
            { name: 'Dashboard', href: '/' },
            { name: 'Add-on Product', href: '/addon-product' },
          ]}
        />
        <AddOnProductForm />
      </Container>
    </Page>
  );
};

export default index;
